module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.05.b-ef6c058268520475ca0076e2c0d11ac0.svg";